import IsEqual from 'lodash.isequal';
import moment from 'moment';

const checkConditions = function(conditions, link = 'and', data) {
  let res = true;
  for (let cond of conditions) {
    if (cond.type === "condition" && cond.compareField) {
      let cmpValue = data[cond.compareField];
      if (cond.compareField.split('.').length > 1) {
        let cmpField = cond.compareField.split('.');
        cmpValue = (data[cmpField[0]]) ? data[cmpField[0]][cmpField[1]] : null;
      }

      if (cond.compareType === "eq") {
        res = IsEqual(cmpValue, cond.compareValue);
      } else if (cond.compareType === "neq") {
        res = !IsEqual(cmpValue, cond.compareValue);
      } else if (cond.compareType === "empty") {
        res = !cmpValue;
      } else if (cond.compareType === "nempty") {
        res = cmpValue;
      } else if (cond.compareType === "lt") {
        if (!cmpValue) {
          res = false;
        } else if (!isNaN(cond.compareValue)) {
          res = cmpValue < cond.compareValue;
        } else if (moment(cond.compareValue).isValid()) {
          res = moment(cond.compareValue).isAfter(moment(cmpValue.date));
        }
      }  else if (cond.compareType === "gt") {
        if (!cmpValue) {
          res = false;
        } else if (!isNaN(cond.compareValue)) {
          res = cmpValue > cond.compareValue;
        } else if (moment(cond.compareValue).isValid() && cmpValue.date && moment(cmpValue.date).isValid()) {
          res = moment(cond.compareValue).isBefore(moment(cmpValue.date));
        }
      } else if (cond.compareType === "selected") {
        res = cmpValue instanceof Array &&
          cmpValue.indexOf(cond.compareValue) !== -1;
      } else if (cond.compareType === "nselected") {
        res = !(cmpValue instanceof Array) ||
          cmpValue.indexOf(cond.compareValue) === -1;
      }
    } else if (cond.type === "group") {
      res = checkConditions(cond.data, cond.link || 'and', data);
    }

    if (link === "or" && res) {
      return true;
    } else if (link === "and" && !res) {
      return false;
    }
  }

  return link !== "or";
};

const checkFieldValid = function (form, data, el) {
  // element not visible
  if (el.visibility && !checkConditions(el.visibility, el.vLink || 'and', data)) {
    return true;
  }

  if (el.options && el.options.required) {
    if (el.type === 'input' && (!data[el.id] || /^\s*$/.test(data[el.id]))) {
      return false;
    } else if (data[el.id] === undefined || data[el.id] === null) {
      return false;
    }
  }

  return true;
};

const checkFormValid = function (form, data) {
  for (const el of form) {
    if (!checkFieldValid(form, data, el)) {
      return false;
    }

    if (el.type === 'form_group') {
      console.log(el)
      if (el.options.duplicateable) {
        for (const subData of data[el.id]) {
          if (!checkFormValid(el.elements, subData)) {
            return false;
          }
        }
      } else {
        if (!checkFormValid(el.elements, data[el.id])) {
          return false;
        }
      }
    }
  }

  return true;
};

export { checkConditions, checkFormValid, checkFieldValid };
